// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Nav from './Components/Nav';
import Home from './Components/Home';

const App = () => {
  const homeDetails = {
    title: 'Welcome to Roxil Hotel',
    subtitle: 'Your perfect Gateway Destination',
    description: `Experience the pinnacle of indulgence and serenity at Roxil Hotel, where luxurious accommodations 
                   and world-class amenities come together to create an unforgettable vacation.`,
    highlights: [
      'Luxurious rooms with breathtaking views',
      'Award-winning dining experience',
      'Relaxing spa and wellness facilities',
      'Convenient location for exploring the city'
    ]
  }
  return (
    <> 
    <Nav />
    <Home details={homeDetails} />
    <Routes>    
    </Routes>
    </>
  );
};

export default App;
